import { createFileRoute } from '@tanstack/react-router'

export const SETTINGS_TABS = ['general', 'team', 'clients', 'integrations', 'assistants', 'danger'] as const
export type SettingsTab = (typeof SETTINGS_TABS)[number]

export interface SettingsSearch {
  tab?: SettingsTab
  /** Opens the add-client drawer on the Clients tab (the topbar's Invite client). */
  add?: boolean
}

export const Route = createFileRoute('/$orgSlug/$clientSlug/settings')({
  validateSearch: (search: Record<string, unknown>): SettingsSearch => ({
    tab: (SETTINGS_TABS as readonly unknown[]).includes(search.tab) ? (search.tab as SettingsTab) : undefined,
    // The router JSON-parses search values, so `?add=1` arrives as the number 1.
    add: search.add === true || search.add === 1 || search.add === '1' || search.add === 'true' ? true : undefined,
  }),
})
